import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import CodeMirrorLight from '@/components/CodeMirrorLight';

function Script({ log }) {
  return (
    <Root className='narrow-scrollbar'>
      <CodeMirrorLight value={log?.execContend || ''} readOnly />
    </Root>
  );
}

export default connect((state) => ({
  log: state.execRecord.logs[0],
}))(Script);

const Root = styled.div`
  margin-top: 6px;

  width: 100%;
  .cm-editor {
    height: 500px;
  }
`;
